import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import sessionStorage from 'redux-persist/lib/storage/session';
import auth from './auth';
import routing from './routing';
import login from './login';
import envSetting from './envSetting';
import event from './event';
import deviceCode from './deviceCode';
import boothDeviceCode from './boothDeviceCode';
import profile from './profile';
import emailTemplate from './emailTemplate';
import emailList from './emailList';
import emailRecord from './emailRecord';
import smsDraft from './smsDraft';
import smsRecord from './smsRecord';
import parameter from './parameter';
import point from './point';
import statistic from './statistic';
import file from './file';
import healthForm from './healthForm';
import systemSetting from './systemSetting';
import commonAction from './commonAction';
import accountFeature from './accountFeature';
import indexPage from './indexPage';
import isSavedNotYet from './isSavedNotYet';
import badge from './badge';
import modalVisible from './modalVisible';

// ------------------ client ------------------
import clientOrder from './clientOrder';

import * as actionTypes from '../actionTypes';
import * as variable from '../utils/commonVariable';

const envSettingConfig = {
  key: 'env',
  storage,
  debug: true,
};

const clientOrderConfig = {
  key: 'clientOrder',
  storage: sessionStorage,
  debug: true,
};

const appReducers = combineReducers({
  envSetting: persistReducer(envSettingConfig, envSetting), // 需要儲存在 localStorage 的參數
  clientOrder: persistReducer(clientOrderConfig, clientOrder), // 來賓預訂票券相關參數
  auth, // 登入前的 API 狀態和 token 資訊
  accountFeature, // account feature
  login, // 存 token id
  routing, // 存當前 event 相關的值(待所有變數轉移到 event 就移除)
  event, // 存當前 event 相關的值
  deviceCode, // 活動啟動碼的 API 狀態
  boothDeviceCode, // 攤位啟動碼的 API 狀態
  profile, // profile  API 狀態
  parameter, // 存一些共用、常用的參數，如視窗寬度(windowInnerWidth)
  emailTemplate, // email template 的 API 狀態
  emailList, // email 草稿、發送 List 與詳細草稿的 API 狀態
  emailRecord, // email 發送記錄的 API 狀態
  point, // 點數相關的 API狀態與存點數值
  file, // 檔案上傳的 API 狀態
  smsDraft, // SMS 草稿、發送 List 與詳細草稿的 API 狀態
  smsRecord, // sms 發送記錄的 API 狀態
  healthForm, // 健康聲明表單設定
  statistic, // 報到統計頁面的 API 狀態
  indexPage, // index page API 狀態
  badge, // badge API 狀態
  isSavedNotYet, // 頁面尚未儲存的阻擋提示 狀態
  systemSetting, // 系統相關設定的 API 狀態
  commonAction, // 共用的 API 狀態，如第一次使用的 API 狀態
  modalVisible, // Modal component 可視狀態
});

const reducers = (state, action) => {
  let initialState = { ...state };
  if (action.type === actionTypes.INITIALIZE_ALL_STATES) {
    storage.removeItem(variable.localStoargePersistRoot);
    // 清空後要設定 state 的值，不然會 error
    initialState = {
      envSetting: { ...state.envSetting },
    };
  }
  return appReducers(initialState, action);
};

export default reducers;
